import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { usePurchaseOfferModel } from "../purchaseOfferModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchaseOfferDetailsModel } from "./details/purchaseOfferDetailsModel"
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";
import { OnGetGoodPrint } from "./onGetGoodPrint";


export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, exportPurchaseOffer, setPrint } = usePurchaseOfferModel();
    const { setDetailEditForm, setDetailDataSource } = usePurchaseOfferDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const [visible, setVisible] = useState(false);
    const [printDeliverGoodsVisible, setPrintDeliverGoodsVisible] = useState<boolean>(false);
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-7-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRow.id as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "采购报价跳转详情",
                type: "warning",
                text: "您还有采购报价详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRow.id as string, mode: "edit" });
                    // updateEditFormVal(null);
                    setDetailEditForm({})
                    setDetailDataSource([])
                }
            })
        }
    }
    const desc: IDescription[] = [
        {
            label: "计划总量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "计划总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        }
    ]
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-7-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.id as string, mode: "look", },
            true
        );

    }
    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrintDeliverGoodsVisible(true)
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_OFFER_EDIT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_OFFER_LOOK}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_OFFER_EXPORTPURCHASEOFFER}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { exportPurchaseOffer().then() }}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_OFFER_ONPRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint()}
            >单据打印</Button>
        </YhAuth>
    </>;

    return (
        <>
            {/* <YhBox title={"采购报价列表"} descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}> */}
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            <OnGetGoodPrint onGetGoodPrintVisible={printDeliverGoodsVisible} setOnGetGoodPrintVisible={setPrintDeliverGoodsVisible} />
        </>
    )
}